import { Routes } from "@angular/router";
import { PageLayoutComponent } from "./components/shared/page-layout/page-layout.component";
import { AboutComponent } from "./components/about/about.component";
import { FaqComponent } from "./components/faq/faq.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { TermsAndConditionsComponent } from "./components/terms-and-conditions/terms-and-conditions.component";
import { ImprintComponent } from "./components/imprint/imprint.component";
import { PrivacyPoliciesComponent } from "./components/privacy-policies/privacy-policies.component";
import { UnsubscribeComponent } from "./components/unsubscribe/unsubscribe.component";
import { HomeComponent } from "./components/home/home.component";
import { JobsComponent } from "./components/jobs/jobs.component";

export const pageRoutes: Routes = [
    {
      path: '',
      component: PageLayoutComponent,
      children: [
        {
          path: '',
          loadComponent: () => import('./components/home/home.component').then(component => component.HomeComponent),
          data: {
            title: 'Home Page',
            description: 'Welcome to the home page of our application.',
          },
        },
        {
          path: 'about-us',
          component: AboutComponent,
        },
        {
          path: 'jobs',
          loadComponent: () => import('./components/jobs/jobs.component').then(component => component.JobsComponent),
        },
        {
          path: 'jobs/description/:id',
          loadComponent: () => import('./components/job/job.component').then(component => component.JobComponent),
        },
        {
          path: 'employers',
          loadComponent: () => import('./components/employers/employers.component').then(component => component.EmployersComponent),
        },
        {
          path: 'employees',
          loadComponent: () => import('./components/employees/employees.component').then(component => component.EmployeesComponent),
        },
        {
          path: 'faqs',
          component: FaqComponent,
        },
        {
          path: 'page-not-found',
          component: PageNotFoundComponent,
        },
        {
          path: 'terms-and-conditions',
          component: TermsAndConditionsComponent,
        },
        {
          path: 'imprint',
          component: ImprintComponent,
        },
        {
          path: 'privacy-policies',
          component: PrivacyPoliciesComponent,
        },
        {
          path: 'unsubscribe',
          component: UnsubscribeComponent,
        },
        {
          path: 'unsubscribe/:id',
          component: UnsubscribeComponent,
        },
      ],
    },
]
